export const data = [
	{
		to: '/',
		text: 'Sobre',
		id: 'about',
	},
	{
		to: '/signup',
		text: 'Registrar-se',
	},
];